import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { formatArrivalDate } from '../../../../../../utils/Functions';
import { ItineraryService } from '../../../../../../shared/itinerary.service';
import { CurrencyConverterPurePipe } from 'app/shared/currency-converter-pure.pipe';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { MaterialModalAlertComponent } from 'app/shared/material-modal-alert/material-modal-alert.component';
import { ConfirmationModalComponent } from 'app/shared/modals/confirmation-modal/confirmation-modal.component';
import { MaterialModalConfirmComponent } from 'app/shared/material-modal-confirm/material-modal-confirm.component';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ResultsSearchService } from 'app/home/results-search.service';
import { RestService } from 'app/shared/rest.service';
import { ModalLoadingComponent } from 'app/shared/modal-loading/modal-loading.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-item-insurance',
  templateUrl: './item-insurance.component.html',
  styleUrls: ['./item-insurance.component.scss'],
    providers: [CurrencyConverterPurePipe]
})
export class ItemInsuranceComponent implements OnInit {

  @Input() dato: any;
  @Input() pickUp? : number;
  @Input() isCheckIn: boolean;
  @Input() isEnded: boolean = false;
  @Input() partialReserve: boolean;
  @Input() permissions: any[] = [];
  @Input() currencies: any[];
  @Input() currencyAgency: any;
  @Input() clientSetting: any;
  @Output() itemToPartial = new EventEmitter<number>();
  @Output() itemDelete = new EventEmitter<any>();
  @Output() editItem = new EventEmitter<any>();
  @Output() cancelOrDeleteEmitter = new EventEmitter<any>();
  @Output() delete = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<string>();

  public formatDate = formatArrivalDate;
   currentDate = new Date();
  fontSizeAdjustments = { 6: -1, 8: -2, 10: -5 };
        bsModalRef?: BsModalRef;

  constructor(private itineraryService: ItineraryService,
    private currencyPipe: CurrencyConverterPurePipe,
     private router: Router,
       private resultsSearch: ResultsSearchService,
        private restService :RestService,
        private modalService: BsModalService,
       public dialog: MatDialog,
           private ngxSpinner: NgxSpinnerService,
           public _restService: RestService,
           private notificationService: NotificationService,
    public userService: UserService) { }

  ngOnInit() {
    if (typeof this.dato.item === 'string') {
      this.dato.item = JSON.parse(this.dato.item);
    }
  }

  toPartialReserve(event, item: any){
    if ( event.target.checked ) {
      this.itineraryService.updateItineraryPartial(item);
      this.itemToPartial.emit(1);
    } else {
      this.itineraryService.updateItineraryPartial(item,true);
      this.itemToPartial.emit(-1);
    }
  }

  fontPrice(price){
    if((price.length - 6) > 0){
      const fact = price.length - 6
      const size = 25 - (1.5 * fact)
      return size + 'px'
    }
  }

  getPrice(item): number {

      if(item.status_id == 5) {
        return 0;
      }

      let price: number;

      if(!item.isPendigApprovePay && !item.isPaidAgency && !item.isPaidProvider) {
        price = item.totalPriceProf;

        price = this.currencyPipe.transform(
                                              price,
                                              item?.currency,
                                              this.currencyAgency?.code,
                                              this.currencies
                                            );
      }

      if(item.isPendigApprovePay || item.isPaidAgency || item.isPaidProvider) {
        if(item.converted_amounts) {
          price = item.converted_amounts.netPriceAgent;
        } else {
          price = item.totalPriceProf;
        }


      }

      return price

    }

     getDateArrivalApprove(dateArrival: any): boolean {
    return new Date(dateArrival) >= this.currentDate;
  }

  edit(item: any){
      const message = '¿Deseas eliminar este producto y buscar un nuevo '+ this.dato.categoryName + ' en ' + this.dato.location + ' del ' + this.returnDate(this.dato.arrivalDate) + ' hasta ' +  this.returnDate(this.dato.departureDate) +' para ' + this.dato.paxAdults + ' adultos?';



        const initialState: ModalOptions = {
          initialState: {
            title: 'Eliminar',
            message: message.replace(/\?/g, '?<br />'),
            icon: 'assets/icons/itinerary-detail/04-01.svg'
          }
        };

      this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
        const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe(async (result: boolean) => {
        if(result){
           await this.makePayload(item);
            await this.itineraryService.remove(item !== undefined ? item : item);
        }else{

        }
          confirmSubscription.unsubscribe();
      });
    }

        returnDate(date: any) {
          let dateSplit = date.split("-");
          return (
            "" +
            dateSplit[2] +
            "-" +
            moment()
              .month(parseInt(dateSplit[1]) - 1)
              .format("MMM")
          );
        }



      makePayload(item: any) {
          const _payload = [];

          const  payload = item.payloadUpdate.products[0];
          const form = item.form;
          _payload[0] = payload;

          localStorage.setItem("form", JSON.stringify(form));
          localStorage.setItem("payload", JSON.stringify(_payload));
          this.openModalLoading(JSON.parse(localStorage.getItem("payload")));
          this.restService.doPost("app", "search", payload).subscribe(
                  (response: any) => {
                    if (response !== null && response.results !== null) {
                      const payloadArray = [payload];
                      this.resultsSearch._setPayload(payloadArray);
                      localStorage.setItem("form", JSON.stringify(form));
                      localStorage.setItem("payload", JSON.stringify(payloadArray));
                      this.resultsSearch._setOrigin(item.categoryName);

                      this._setSearchIdInResults(response);
                      if (response.results.length > 0) {
                        this._handleResponse(response, item.categoryName, item);
                        this.dialog.closeAll();
                        this.itineraryService.notifyModalClosed(true);
                        this.router.navigate(["/results"]);
                      } else {
                        var dialogRef = this.dialog.open(MaterialModalAlertComponent, {
                          height: "auto",
                          width: "350px",
                          data: "No se encontraron Resultados",
                          disableClose: true,
                        });
                      }
                    }
                  },
                  (error) => {
                    const message = "Ocurrió un error al intentar encontrar productos";
                    this.dialog.closeAll();
                    var dialogRef = this.dialog.open(MaterialModalConfirmComponent, {
                      width: "450px",
                      data: {message: message},
                      disableClose: true,
                    });
                    dialogRef.afterClosed().subscribe((result) => {
                      if (result) {
                        this.makePayload(item);
                      } else {
                        this.dialog.closeAll();
                      }
                    });
                  }
                );
        }

          _setSearchIdInResults(response: any) {
        response.results.forEach((obj) => {
          obj.searchId = response.searchId;
        });
      }


              /// modal loading
              openModalLoading(data: any) {
                var dialogRef = this.dialog.open(ModalLoadingComponent, {
                  width: "650px",
                  id: "loadModal",
                  data: data,
                  disableClose: true,
                });

                /* dialogRef.afterClosed().subscribe(result => {
                  });*/
              }

  _handleResponse(response: any, categoryName: string, payload: any) {
    if (response && response.results != null) {
      try {
        let _resultsQuery: any;
        _resultsQuery = response.results;
        _resultsQuery.categoryName = categoryName;
        _resultsQuery.arrivalDate = payload.arrivalDate;
        _resultsQuery.destination = payload.destination.iata_code;
        if (!response.results.length) {
          _resultsQuery.noResultMessage = "No results found for the search";
        }
        const arrayResults = [_resultsQuery];

        this.resultsSearch._setResponse(arrayResults);
      } catch (e) {
        console.log("error", e);
      }
    }
  }

    removeItem(item: any) {
    let message = "";

    if ((item.status_id == 1) ||  (item.status_id == 5)) {
      message = "Esta seguro de Eliminar el Producto?";
    }
    if (item.status_id == 2) {
      if(this.verifiedReservationId(item)) {
        message = "Hay más productos con el mismo localizador ¿Está seguro de cancelar los productos?";
      } else {
        message = "¿Esta seguro de cancelar el producto?";
      }
    }

    const initialState: ModalOptions = {
      initialState: {
        title: item.status_id === 2 ? 'Cancelar' : 'Eliminar',
        message: message.replace(/\?/g, '?<br />'),
        icon: 'assets/icons/itinerary-detail/04-01.svg'
      }
    };

    this.bsModalRef = this.modalService.show(ConfirmationModalComponent, initialState);
    const confirmSubscription = this.bsModalRef.content.confirmResult.subscribe((result: boolean) => {
      if(result) {
          const paxesQty = {
            destination: item.destination?.iata_code,
            adults: Number(item.paxAdults),
            children: Number(item.paxChildren)
          }
          this.userService.itineraryActive[0]['destination'].forEach((destination: any) => {
              if(destination.iata_code === paxesQty.destination) {
                destination.destination_info.adults -= paxesQty.adults;
                destination.destination_info.childs -= paxesQty.children;
              }
          });
        if((item.status_id == 1) ||  (item.status_id == 5) ) {

          this.deleteItem(item);
        }
        if (item.status_id == 2) {
          this.cancelReservation(item);
        }
      } else {

      }
      confirmSubscription.unsubscribe();
    });
  }

  verifiedReservationId(item): boolean {
    let matchReservationId: any[] = [];
     matchReservationId =  this.userService.itineraryActive[0].items.filter(c => c.resultReserve?.reservation?.providerReservationId === item?.resultReserve?.reservation?.providerReservationId);
    return matchReservationId && matchReservationId.length > 1;
  }

    deleteItem(item: any) {
    this.itineraryService.remove(item !== undefined ? item : item);
    setTimeout(() => {
      this.delete.emit(item.id);
     this.userService.updateProductsPrices(item.itinerary_id);
    }, 1000);
  }

    cancelReservation(item: any) {

  const productsIdArr = item.id;


      this.ngxSpinner.show();
      let cancelData: any = {};
      cancelData['providerId'] = item?.providerId
      cancelData['reservationLocator'] = item?.resultReserve?.reservation?.providerReservationId;
      cancelData['productsId'] = [productsIdArr];

      const itemCancelled = this.userService.itineraryActive[0].items.find(c => c.id === item.id);

      itemCancelled.amount_convert_cancellation= this.getCancellationPolicies(itemCancelled.category_id, item);
      this.userService.itineraryActive[0].clientId = this.itineraryService.itinerary.client_id;

      this._restService.doPut("app", `products/cancelReservation/${item?.itinerary_id}`, cancelData).subscribe({
        next: (res: any) => {
          this.ngxSpinner.hide();
          this.cancel.emit(item.id);
          this.notificationService.success('Su producto fue cancelado con éxito');
        this.itineraryService.updateItinerary(this.userService.itineraryActive[0], false);
      },
      error: (error: HttpErrorResponse) => {
        this.ngxSpinner.hide();
        this.notificationService.error('Ocurrio un error');
        console.log(error);
      }
    });
      // this.itineraryService.cancelReservation(item);

      // setTimeout(() => {
      //   this.cancel.emit(item.id);
      //   this.userService.updateProductsPrices(item.itinerary_id);
      // }, 1000);


    }

    getCancellationPolicies(category, item) {
    const currentDate = new Date();
    const defaultPolicy = {
        currency: this.currencyAgency?.code,
        from: currentDate,
        amount: 0,
        apply: false
    };

    // Determinar el array de políticas según la categoría
    let policies = [];
    if (category === 1) {
        policies = item.room?.cancellationPolicy || [];
    } else if (category === 8) {
        policies = item.cancellationPolicies || [];
    } else if (category === 10) {
        policies = item.cancellationPolicies || [];
    }

    // Si no hay políticas, retornar el default
    if (policies.length === 0) {
        return [defaultPolicy];
    }

    // Ordenar políticas por fecha 'from'
    const sortedPolicies = [...policies].sort((a, b) =>
        new Date(a.from).getTime() - new Date(b.from).getTime()
    );

    // Encontrar la política aplicable
    let applicableIndex = -1;
    for (let i = 0; i < sortedPolicies.length; i++) {
        if (new Date(sortedPolicies[i].from) <= currentDate) {
            applicableIndex = i;
        } else {
            break;
        }
    }

    // Preparar el resultado con el campo apply
    const result = sortedPolicies.map((policy, index) => {
      const baseRate = this.currencies.find(c => c.code === policy.currency)?.rate || 1;
      const targetRate = this.currencyAgency?.rate || 1;

        const isApplicable = index === applicableIndex;
        const amount = (policy.amount / baseRate) * targetRate;

        return {
            ...policy,
            currency: this.currencyAgency?.code,
            amount: amount,
            apply: isApplicable
        };
    });

    // Si no hay ninguna aplicable y hay políticas, marcamos todas como no aplicables
    if (applicableIndex === -1 && result.length > 0) {
      const targetRate2 = this.currencyAgency?.rate || 1;
      return result.map(policy => ({
            ...policy,
            currency: this.currencyAgency?.code,
            amount: (policy.amount / this.currencies.find(c => c.code === policy.currency)?.rate) * targetRate2,
            apply: false
        }));
    }

    return result;
}



}
